import { produce } from 'immer';
import { BarChartSpec, VisualOverride } from '@/core';
import { OptionsEditorColumn, OptionsEditorGrid } from '@/plugin-editor-components';
import { OverrideOptions } from '@/plugin-system/components/editing/OverridesEditor/types';
import { OverrideColorPicker, OverridesEditor, OverridesEditorProps } from '../../../plugin-system';
import { BarChartOptionsEditorProps } from './bar-chart-model';

const options: OverrideOptions<VisualOverride> = {
  color: {
    title: 'Color',
    property: 'color',
    Component: OverrideColorPicker,
  },
};

export function BarChartOptionsEditorAdvancedSettings(props: BarChartOptionsEditorProps) {
  const { value, onChange } = props;

  const handleOverridesChange: OverridesEditorProps<VisualOverride>['onChange'] = (overrides) => {
    onChange(
      produce(value, (draft: BarChartSpec) => {
        draft.overrides = overrides;
      })
    );
  };

  return (
    <OptionsEditorGrid>
      <OptionsEditorColumn>
        <OverridesEditor
          overrideOptions={options}
          overrides={props.value.overrides ?? []}
          onChange={handleOverridesChange}
        />
      </OptionsEditorColumn>
    </OptionsEditorGrid>
  );
}
